// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".personal-information .uplay tr{height:30px}.personal-information .uplay tr td:first-child{padding-right:30px;font-weight:bolder}.personal-information .uplay .uplay-href{margin-top:.89rem}.personal-information .about-you .btn-yes-no{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
